module.exports = morningstar;